import { callJwtVerification, JWT_EXPIRED_HEARTBEAT } from "../../ducks/user";
import UserArea from "./UserArea";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { doLogout } from "../../ducks/logout";
import { IS_LOGGED_IN_KEY, ROLES } from "../../ducks/login";
import { LOGIN_STORE, USER } from "../../common/constant";

const mapStateToProps = (state) => {
  return {
    [JWT_EXPIRED_HEARTBEAT]: state[USER][JWT_EXPIRED_HEARTBEAT],
    [ROLES]: state[LOGIN_STORE][ROLES],
    [IS_LOGGED_IN_KEY]: state[LOGIN_STORE][IS_LOGGED_IN_KEY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      callJwtVerification,
      doLogout
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArea);
